import React from 'react';
import { FaPencilAlt } from '@react-icons/all-files/fa/FaPencilAlt';

export interface WindowHeaderProps {
  title: React.ReactNode;
  /** Si se define, el título actúa como control para esta acción (p. ej. abrir un modal). */
  onTitleClick?: () => void;
  onClose?: (event?: React.MouseEvent) => void;
  /** Contenido extra a la derecha (p. ej. botón +) antes del lápiz de editar grupo. */
  headerExtraRight?: React.ReactNode;
  /** Acción opcional a la derecha (p. ej. editar grupo cuando hay empresa seleccionada) */
  onEditGrupo?: () => void;
  /** Si true, el lápiz se muestra pero no es clicable (p. ej. sin permiso de edición). */
  editGrupoDisabled?: boolean;
  /** Color de fondo de la barra (por defecto usa la clase `bg-primary`). */
  headerBackground?: string;
}

const WindowHeader = ({
  title,
  onTitleClick,
  onClose,
  headerExtraRight,
  onEditGrupo,
  editGrupoDisabled = false,
  headerBackground,
}: WindowHeaderProps) => {
  return (
    <div className="col-12 col-md-12">
      <div
        className={`profase-section-header d-flex align-items-center justify-content-between gap-2 text-white p-3${headerBackground ? '' : ' bg-primary'}`}
        style={{ minHeight: 52, ...(headerBackground ? { background: headerBackground } : {}) }}
      >
        <div className="d-flex align-items-center flex-shrink-0" style={{ minWidth: 88 }}>
          {onClose ? (
            <button type="button" className="btn btn-sm btn-light" onClick={e => onClose(e)}>
              Cerrar
            </button>
          ) : (
            <span aria-hidden style={{ width: 1 }} />
          )}
        </div>
        <h5 className="m-0 text-center flex-grow-1 text-white px-2" style={{ lineHeight: 1.3 }}>
          {onTitleClick ? (
            <button
              type="button"
              className="btn btn-link p-0 border-0 shadow-none"
              style={{
                fontSize: '1.25rem',
                fontWeight: 500,
                lineHeight: 1.3,
                color: '#fff',
                textDecoration: 'underline',
                textUnderlineOffset: '0.2em',
              }}
              onClick={onTitleClick}
              aria-label={typeof title === 'string' ? `Ampliar: ${title}` : 'Ampliar'}
            >
              {title}
            </button>
          ) : (
            title
          )}
        </h5>
        <div
          className="d-flex align-items-center justify-content-end flex-shrink-0 gap-1"
          style={{ minWidth: 120 }}
        >
          {headerExtraRight}
          {onEditGrupo ? (
            <button
              type="button"
              className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
              style={{ width: 36, height: 32, padding: 0 }}
              onClick={onEditGrupo}
              disabled={editGrupoDisabled}
              aria-label="Editar grupo"
              title={editGrupoDisabled ? 'No tiene permiso para editar' : 'Editar grupo'}
            >
              <FaPencilAlt />
            </button>
          ) : !headerExtraRight ? (
            <span aria-hidden style={{ width: 1 }} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default WindowHeader;
